
import { Subscription } from 'rxjs';

import { Constants        } from '@constants';
import { Component        } from '@angular/core';
import { HostListener     } from '@angular/core';
import { ActivatedRoute   } from '@angular/router';
import { HttpClient       } from '@angular/common/http';
import { ViewportScroller } from '@angular/common';

import { ConsoleService    } from '@service/console.service';
import { PlatformService   } from '@service/platform.service';
import { FilesystemService } from '@service/filesystem.service';

@Component({
    selector: 'main',
    styleUrls: [ 'main.template.scss' ],
    templateUrl: 'main.template.html'
})
export class MainComponent {

    public menu: boolean = false;

    public start: number = 0;
    public ready: boolean = false;
    public ready2: boolean = false;
    public offset: number = 0;

    public content: any;
    public request?: Subscription;

    public window!: number;

    constructor (private scroller: ViewportScroller,
                 private http: HttpClient,
                 private console: ConsoleService,
                 private route: ActivatedRoute,
                 private platform: PlatformService,
                 private filesystem: FilesystemService) {

    }

    ngOnInit () {
        this.window = window.innerWidth;
        document.body.addEventListener("mousemove", (event:any)=>{
            
            this.window = window.innerWidth;
        })

        document.body.addEventListener("keydown", (event:any)=>{
            console.log("key")
            this.window = window.innerWidth;
        })
        document.body.addEventListener("resize", (event:any)=>{
            console.log("resize")
            this.window = window.innerWidth;
        })
        this.console.group('MainComponent');
        this.console.info('Starting');

        this.start = (new Date).getTime();

        this.setLanguage();
        this.getContent();
        this.getSellers();

        this.route.params.subscribe((params: any) => {
            this.filesystem.writeSession('seller', params.seller ? params.seller : '');
        });
    }

    ngOnDestroy () {
        this.console.info('Destroying');
        this.console.group();
    }

    get fill () {
        let a: any = document.querySelector('section-banner');
        return window.scrollY >= (a ? a.clientHeight - 80 : 10000);
    }

    get seller () {
        let seller: any = this.filesystem.readSession('seller');
        let sellers: any = this.filesystem.readSession('sellers');

        if (seller && sellers) {
            if (typeof sellers.sellers[seller] != 'undefined'
             && typeof sellers.companies[sellers.sellers[seller].company] != 'undefined') {
                return true;
             }
        }

        return null;
    }

    get language () {
        return this.filesystem.readSession('language');
    }

    public toggleLanguage () {
        document.querySelector('.main')!.classList.add('fade');

        setTimeout(() => {
            localStorage.language = this.language == 'en' ? 'pt' : 'en';
            this.filesystem.writeSession('language', this.language == 'en' ? 'pt' : 'en');
            document.querySelector('.main')!.classList.remove('fade');
        }, 800);
    }

    @HostListener('window:scroll', [ '$event' ])
    public parallaxByScroll ($event: any) {
        this.offset = -window.scrollY / 3;
    }

    public scrollTo ($event: any, anchor: string) {
        $event.preventDefault();
        this.menu = false;
        this.scroller.scrollToAnchor(anchor);
    }

    protected setReady () {
        this.console.info('Displaying content');

        let time = (new Date).getTime() - this.start;
        let delay = 2000 - time;
            delay = delay > 0 ? delay : 0;

        setTimeout(() => {
            this.ready = true;

            setTimeout(() => {
                this.ready2 = true;
            }, 500);
        }, delay);
    }

    protected setLanguage () {
        let language: string = localStorage.language;
        if (! language) {
            let nav: any = window.navigator;
            language = nav.userLanguage || nav.language;
        }

        if (language.indexOf('en') !== -1 || language.indexOf('EN') !== -1) {
            this.filesystem.writeSession('language', 'en');
        } else {
            this.filesystem.writeSession('language', 'pt');
        }
    }

    protected getSellers () {
        this.console.info('Getting sellers');

        this.request = this.http.get(`${Constants.sellers}`).subscribe(
            (response: any) => {
                this.console.info('Received sellers');
                this.filesystem.writeSession('sellers', response);
            }
        );
    }

    protected getContent () {
        this.console.info('Getting content');

        let main: any = this.filesystem.readSession('main');
        if (main) {
            this.console.info('Found cached content');
            this.content = main;

            return;
        }

        this.console.info('Getting fresh content');
        this.request = this.http.get(`${Constants.backend}/main${Constants.extension}`).subscribe(
            (response: any) => {
                this.setReady();

                this.console.info('Received content');
                this.content = response;

                this.filesystem.writeSession('main', response);
            }
        );
    }

}
